// src/components/Navbar.jsx
import React, { useContext, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import { FaBell, FaSearch, FaSignOutAlt, FaChevronDown } from "react-icons/fa";
import logo from "../assets/logo.png";
import Loader from "./Loader";

export default function Navbar() {
  const { user, logout, loading } = useContext(AuthContext);
  const [open, setOpen] = useState(false);

  if (loading) {
    return (
      <header className="flex justify-center items-center h-16 bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-600">
        <Loader />
      </header>
    );
  }

  return (
    <header className="flex items-center justify-between bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-600 backdrop-blur-md shadow-md px-6 py-3 sticky top-0 z-40">
      {/* Left Section - Logo + Search */}
      <div className="flex items-center gap-6">
        <img src={logo} alt="Logo" className="w-11 h-11 rounded-full shadow-md" />
        <div className="hidden md:flex items-center bg-white/20 backdrop-blur-md rounded-full px-4 py-2">
          <FaSearch className="text-white/80 mr-2" />
          <input
            type="text"
            placeholder="Search..."
            className="bg-transparent outline-none text-sm w-56 text-white placeholder:text-white/70"
          />
        </div>
      </div>

      {/* Right Section */}
      <div className="flex items-center gap-6">
        <button className="relative hover:scale-110 transition">
          <FaBell className="text-white text-lg" />
          <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs px-1.5 rounded-full">
            3
          </span>
        </button>

        {user ? (
          <div className="relative">
            <div
              className="flex items-center gap-3 cursor-pointer"
              onClick={() => setOpen(!open)}
            >
              <img
                src={user.avatar || `https://i.pravatar.cc/111?v=${user?.email}`}
                alt="Profile"
                className="w-10 h-10 rounded-full border-2 border-white shadow-md"
              />
              <div className="hidden sm:block text-white">
                <p className="font-semibold">{user.name}</p>
                <p className="text-xs opacity-80">{user.role}</p>
              </div>
              <FaChevronDown
                className={`text-white text-xs transition ${open ? "rotate-180" : ""}`}
              />
            </div>
            {open && (
              <div className="absolute right-0 mt-3 bg-white shadow-lg rounded-lg w-48">
                <button
                  onClick={logout}
                  className="flex items-center gap-2 px-4 py-2 text-red-600 hover:bg-gray-100 w-full text-left"
                >
                  <FaSignOutAlt /> Logout
                </button>
              </div>
            )}
          </div>
        ) : (
          <p className="text-sm text-white/90">Not logged in</p>
        )}
      </div>
    </header>
  );
}
